import mitt from 'mitt'

const emitter = mitt()

// 可选：导出为Vue插件形式
export default {
    install (app) {
        app.config.globalProperties.$bus = emitter
    }
}

// 直接导出emitter
export const bus = emitter
